import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from '@/core/service/room.baseapi.service'

class RoomUXService extends RoomBaseApiService {
  constructor() {
    super()
  }

  async getGroupUX(groupId) {
    try {
      const response = await this.request().get(`/api/v3/group/${groupId}/groupUX`)
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}

export const roomUXService = new RoomUXService()
